import axios from 'axios'
import qs from 'qs'
import store from '@/store/index.js'
import baseURL from './baseURL'
import { Message } from 'element-ui'
import router from '@/router/index.js' // 引入你的路由实例

const instance = axios.create({
    baseURL,
    timeout: 50000
})

instance.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

instance.interceptors.request.use(
    config => {
        // 设置header
        setHeader(config)
        return config
    },
    error => {
        console.log(error)
        return Promise.reject(error)
    }
)

// axios response封装的数据在data里面
instance.interceptors.response.use(
    response => {
        console.log('响应数据', response)
        const res = response.data

        // 你的业务里，即使code=401，success也是true，所以这里要单独处理
        if (res.code === 401 || res.message === 'token非法无效!') {
            // 1. 清除本地token
            localStorage.removeItem('accessToken')
            // 2. 提示用户
            Message.error({
                message: '登录已过期，请重新登录'
            })
            // 3. 跳转到登录页（避免重复跳转）
            if (router.currentRoute.path !== '/login') {
                router.push('/login')
            }
            // 4. 终止后续逻辑，返回拒绝状态
            return Promise.reject(new Error('token无效'))
        }

        // 其他业务错误处理
        if (res.success === false) {
            if (res.code === 500) {
                if (res.message != '该值不可用，系统中已存在！') {
                    Message.error({
                        message: res.message
                    })
                } else {
                    // 正常返回数据
                    return res
                }
            } else {
                Message.error({
                    message: res.message
                })
            }
            return Promise.reject(new Error(res.message || '业务请求失败'))
        }

        // 正常返回数据
        return res
    },
    error => {
        // 网络层面的错误（比如401状态码）
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('accessToken')
            Message.error({
                message: '登录已过期，请重新登录'
            })
            if (router.currentRoute.path !== '/login') {
                router.push('/login')
            }
        } else if (error.message.includes('timeout')) {
            Message.error({
                message: '请求超时，请检查网络'
            })
        } else if (!window.navigator.onLine) {
            Message.error({
                message: '网络连接异常，请检查网络'
            })
        } else {
            Message.error({
                message: '请求失败，请稍后重试'
            })
        }
        console.log('响应错误', error)
        return Promise.reject(error)
    }
)

function setHeader(config) {
    // setHeader
    const token = localStorage.getItem('accessToken')
    if (token) {
        config.headers['X-Access-Token'] = token
    }
}

export default instance